import { 
    ORGANIC_COTTON_PILLOWCASES,
    PERCALE_PILLOWCASES,
    SATEEN_COTTON_PILLOWCASES,
    BANDED_PERCALE_PILLOWCASES,
    LINEN_PILLOWCASES,
    ESSENTIAL_PILLOWCASES,
    FLANNEL_PILLOWCASES,
    EMBROIDERED_PILLOWCASES,
    AERO_QUILT,
    BANDED_PERCALE_DUVET_SET,
    BANDED_PERCALE_SHEET_SET,
    DIAMOND_KNIT_BLANKET,
    DOWN_ALTERNATIVE_COMFORTER,
    EMBROIDERED_HOTEL_STYLE_SHEETS,
    EMBROIDERED_SATEEN_DUVET_SET,
    ESSENTIAL_DUVET_COVER_SET,
    SIGNATURE_DUVET_COVER_SET,
    ESSENTIAL_SHEET_SET,
    FEATHERBED_MATTRESS_TOPPER,
    FLANNEL_SHEET_SET,
    GRAPHITE_MEMORY_FOAM_MATTRESS_TOPPER,
    HEAVYWEIGHT_COMFORTER,
    HERRINGBONE_KNIT_BLANKET,
    HIGH_DENSITY_FOAM_MATTRESS_TOPPER,
    LATEX_MATTRESS_TOPPER,
    LIGHTWEIGHT_DOWN_ALTERNATIVE_COMFORTER,
    LINEN_DUVET_COVER_SET,
    LINEN_SHEET_SET,
    MICROCOIL_MATTRESS_TOPPER,
    ORGANIC_COTTON_CHANNEL_QUILT,
    ORGANIC_COTTON_SHEETS,
    ORGANIC_MATTRESS_PAD,
    ORGANIC_QUILTED_MATTRESS_TOPPER,
    ORGANIC_SATEEN_DUVET_COVER_SET,
    ORGANIC_VELVET_QUILT,
    PERCALE_DUVET_COVER_SET,
    PERCALE_SHEET_SET,
    PLUSH_TOWELS,
    SATEEN_COTTON_SHEET_SET,
    SWEATER_KNIT_BLANKET,
    WAFFLE_KNIT_BLANKET,
    WAFFLE_KNIT_DUVET_COVER_SET,
    WAFFLE_TOWELS,
    WATERPROOF_MATTRESS_PROTECTOR,
    WEIGHTED_BLANKET,
    THE_SAATVA_PILLOW,
    ORGANIC_QUILTED_PILLOW,
    CLOUD_MEMORY_FOAM_PILLOW,
    DOWN_ALTERNATIVE_PILLOW,
    MEMORY_FOAM_PILLOW,
    SILK_PILLOWCASE,
    SIGNATURE_MATTRESS_PAD
} from '@/constants/product-codes'

import styles from './SizeGuide.module.scss'

const sharedSizes = (productTitle, hasFooter, hasUpperFlex, excludeFlanged = 1) => {
    return {
        pillowcases: {
            head: {
                content: []
            },
            body: {
                content: [
                    [
                        'Standard',
                        '32" x 21"'
                    ],
                    [
                        'King',
                        '41" x 21"'
                    ]
                ]
            },
        },
        [`${ORGANIC_COTTON_SHEETS}`]: {
            head: {
                content: [ // Each object corresponds to a <th>
                    '',
                    {
                        title: 'Flat Sheet',
                        subtitle: 'W x L'
                    },
                    {
                        title: 'Fitted Sheet',
                        subtitle: 'W x L x D'
                    },
                    {
                        title: 'Pillowcase',
                        subtitle: 'W x L'
                    }
                ]
            },
            body: {
                content: [ // Each array correstpond to a <tr>
                    [
                        'Twin',
                        '72" x 110"',
                        '39" x 75" x 16"',
                        {
                            title: 'Standard/Queen </br>32" x 21"',
                            rowSpan: '5',
                            className: 'dataEntry--pillows'
                        }
                    ],
                    [
                        'TWIN XL',
                        '72" x 114"',
                        '39" x 80" x 16"'
                    ],
                    [
                        'FULL',
                        '92" x 110"',
                        '54" x 75" x 16"'
                    ],
                    [
                        'QUEEN',
                        '96" x 114"',
                        '60" x 80" x 16"'
                    ],
                    [
                        'QUEEN </br>UPPER-FLEX',
                        '96" x 114"',
                        '60" x 80" x 16" </br>(Upper-Flex Style)'
                    ],
                    [
                        'KING',
                        '114" x 114"',
                        '76" x 80" x 16"',
                        {
                            title: 'King </br>41" x 21"',
                            rowSpan: '5',
                            className: 'dataEntry--pillows'
                        }
                    ],
                    [
                        'CAL KING',
                        '108" x 114"',
                        '72" x 84" x 16"'
                    ],
                    [
                        'SPLIT KING',
                        '114" x 114"',
                        '39" x 80" x 16" (x2)'
                    ],
                    [
                        'KING </br>UPPER-FLEX',
                        '114" x 114"',
                        '76" x 80" x 16" </br>(Upper-Flex Style)'
                    ]
                ]
            },
            footer: {
                listContent: [
                    '<span class="t-bold">Fitted Sheet</span> fits mattresses 10-16 inches in height',
                    '<span class="t-bold">Twin and Twin XL</span> sets include 1 pillowcase, all other sizes include 2 pillowcases.',
                    '<span class="t-bold">Split King</span> set includes 2 fitted sheets.',
                    '<span class="t-bold">Upper-Flex</span> style fitted sheets are tailored with a split top, designed for Solaire and Zenhaven Upper-Flex mattresses only.'
                ]
            }
        },
        [`${PERCALE_DUVET_COVER_SET}`]: {
            head: {
                content: [ // Each object corresponds to a <th>
                    '',
                    {
                        title: 'Duvet Covers*',
                        subtitle: 'W x L'
                    },
                    {
                        title: 'Pillow Shams',
                        subtitle: 'W x L',
                        titleClassName: 'tableCellPadding'
                    },
                    {
                        title: 'Euro Shams',
                        subtitle: 'W x L'
                    }
                ]
            },
            body: {
                content: [
                    [
                        'TWIN/<br class="u-hidden--sm-up" />TWIN XL',
                        '68" x 90"',
                        {
                            title: `<span class="${styles['tableCell--leftBumper']}">Standard/Queen </br> 20" x 26"</span>`,
                            rowSpan: '2',
                            className: 'dataEntry--duvets'
                        },
                        {
                            title: '26" x 26"',
                            rowSpan: '3',
                            className: 'dataEntry--duvets'
                        }
                    ],
                    [
                        'FULL/<br class="u-hidden--sm-up" />QUEEN',
                        '88" x 92"'
                    ],
                    [
                        'KING/<br class="u-hidden--sm-up" />CAL KING',
                        '106" x 92"',
                        {
                            title: `<span class="${styles['tableCell--leftBumper']}">King</br> 20" x 36"</span>`,
                            className: 'dataEntry--duvets'
                        }
                    ]
                ]
            },
            footer: {
                listContent: [
                    `*All measurements exclude the ${excludeFlanged}” flanged edge trim`,
                    '<span class="t-bold">Twin and Twin XL</span> cover sets include 1 pillow sham, all other sizes include 2 shams.'
                ]
            }
        },
        [`${PERCALE_SHEET_SET}`]: {
            head: {
                content: [
                    '',
                    {
                        title: 'Flat Sheet',
                        subtitle: 'W x L'
                    },
                    {
                        title: 'Fitted Sheet',
                        subtitle: 'W x L x D'
                    },
                    {
                        title: 'Pillowcase',
                        subtitle: 'W x L'
                    }
                ]
            },
            body: {
                content: [
                    [
                        'TWIN',
                        '72" x 110"',
                        '39" x 75" x 16"',
                        {
                            title: '<span>Standard/Queen </br> 32" x 21"</span>',
                            rowSpan: '4',
                            className: 'dataEntry--pillows'
                        }
                    ],
                    [
                        'TWIN XL',
                        '72" x 114"',
                        '39" x 80" x 16"'
                    ],
                    [
                        'FULL',
                        '92" x 110"',
                        '54" x 75" x 16"'
                    ],
                    [
                        'QUEEN',
                        '96" x 114"',
                        '60" x 80" x 16"'
                    ],
                    [
                        'KING',
                        '114" x 114"',
                        '76" x 80" x 16"',
                        {
                            title: '<span>King </br> 41" x 21"</span>',
                            rowSpan: '3',
                            className: 'dataEntry--pillows'
                        }
                    ],
                    [
                        'CAL KING',
                        '108" x 114"',
                        '72" x 84" x 16"'
                    ],
                    [
                        'SPLIT KING',
                        '114" x 114"',
                        '39" x 80" x 16" (x2)'
                    ]
                ]
            },
            footer: {
                listContent: [
                    '<span class="t-bold">Fitted Sheet</span> fits mattresses 10-16 inches in height.',
                    '<span class="t-bold">Twin and Twin XL</span> sets include 1 pillowcase, all other sizes include 2 pillowcases.',
                    '<span class="t-bold">Split King</span> set includes 2 fitted sheets.'
                ]
            }
        },
        [`${WAFFLE_TOWELS}`]: {
            head: {
                content: [ // Each object corresponds to a <th>
                    productTitle || 'Waffle Towels',
                    {
                        subtitle: 'W x H'
                    }
                ]
            },
            body: {
                content: [ // Each array correstpond to a <tr>
                    [
                        'FACE TOWEL*',
                        '13" x 13"'
                    ],
                    [
                        'HAND TOWEL*',
                        '20" x 30"'
                    ],
                    [
                        'BATH TOWEL',
                        '30" x 58"'
                    ],
                    [
                        'BATH SHEET',
                        '40" x 66"'
                    ]
                ]
            },
            footer: {
                listContent: [
                    '*Face towel & hand towel are only available in the <span class="t-bold">3-pc Bath Towel Set</span>'
                ]
            }
        },
        [`${DIAMOND_KNIT_BLANKET}`]: {
            head: {
                content: [ // Each object corresponds to a <th>
                    '',
                    {
                        subtitle: 'W x L'
                    }
                ]
            },
            body: {
                content: [ // Each array correstpond to a <tr>
                    [
                        'TWIN/THROW',
                        '74" x 90"'
                    ],
                    [
                        'FULL/QUEEN',
                        '96" x 96"'
                    ],
                    [
                        'KING/CAL KING',
                        '106" x 96"'
                    ]
                ]
            }
        },
        [`${ORGANIC_MATTRESS_PAD}`]: {
            head: {
                content: [
                    productTitle,
                    'W x L'
                ]
            },
            body: {
                content: [
                    [
                        'TWIN',
                        '38" x 75"'
                    ],
                    [
                        'TWIN XL',
                        '38" x 80"'
                    ],
                    [
                        'FULL',
                        '54" x 75"'
                    ],
                    [
                        'QUEEN',
                        '60" x 80"'
                    ],
                    [
                        'KING/SPLIT',
                        '76" x 80"'
                    ],
                    [
                        'CAL KING/SPLIT',
                        '72" x 84"'
                    ]
                ]
            },
            footer: {
                listContent: hasFooter ? [
                    '<span class="t-bold">Mattress Pad</span> fits mattresses up to 16 inches in height.',
                    '<span class="t-bold">Split King and Split Cal King</span> includes 2 mattress pads.',
                    hasUpperFlex && '<span class="t-bold">Upper-Flex</span> style mattress pads are tailored with a split top, designed for Solaire Upper-Flex mattresses only.'
                ] : []
            }
        },
        [`${SIGNATURE_MATTRESS_PAD}`]: {
            head: {
                content: [
                    productTitle,
                    'W x L'
                ]
            },
            body: {
                content: [
                    [
                        'TWIN',
                        '38" x 75"'
                    ],
                    [
                        'TWIN XL',
                        '38" x 80"'
                    ],
                    [
                        'FULL',
                        '54" x 75"'
                    ],
                    [
                        'QUEEN',
                        '60" x 80"'
                    ],
                    [
                        'KING/SPLIT',
                        '76" x 80"'
                    ],
                    [
                        'CAL KING',
                        '72" x 84"'
                    ]
                ]
            },
            footer: {
                listContent: hasFooter ? [
                    '<span class="t-bold">Mattress Pad</span> fits mattresses up to 16 inches in height.',
                    '<span class="t-bold">Split King</span> includes 2 Twin XL mattress pads.',
                    hasUpperFlex && '<span class="t-bold">Upper-Flex</span> style mattress pads are tailored with a split top, designed for Solaire Upper-Flex mattresses only.'
                ] : []
            }
        },
        [`${DOWN_ALTERNATIVE_COMFORTER}`]: {
            head: {
                content: [ // Each object corresponds to a <th>
                    'Comforter',
                    {
                        subtitle: 'W x L'
                    }
                ]
            },
            body: {
                content: [ // Each array correstpond to a <tr>
                    [
                        'TWIN/TWIN XL',
                        '68" x 90"'
                    ],
                    [
                        'FULL/QUEEN',
                        '88" x 92"'
                    ],
                    [
                        'KING/CAL KING',
                        '106" x 92"'
                    ]
                ]
            }
        }
    }
}

const sizeGuide = {
    [`${AERO_QUILT}`]: {
        head: {
            className: '',
            content: [ // Each object corresponds to a <th>
                '',
                {
                    subtitle: 'W x L'
                }
            ]

        },
        body: {
            content: [ // Each array correstpond to a <tr>
                [
                    'TWIN/TWIN XL',
                    '74" x 91"'
                ],
                [
                    'FULL/QUEEN',
                    '96" x 96"'
                ],
                [
                    'KING/CAL KING',
                    '112" x 96"'
                ]
            ]
        }
    },
    [`${ORGANIC_COTTON_CHANNEL_QUILT}`]: {
        head: {
            className: '',
            content: [ // Each object corresponds to a <th>
                '',
                {
                    title: 'Quilts',
                    subtitle: 'W x L'
                },
                {
                    title: 'Pillow Shams',
                    subtitle: 'W x L',
                    titleClassName: 'tableCell--leftBumper'
                },
                {
                    title: 'Euro Shams',
                    subtitle: 'W x L'
                }
            ]

        },
        body: {
            content: [ // Each array correstpond to a <tr>
                [
                    'TWIN/<br class="u-hidden--sm-up" />TWIN XL',
                    '74" x 90"',
                    {
                        title: `<span class="${styles['tableCell--leftBumper']}">Standard </br> 20" x 26"</span>`,
                        rowSpan: '2',
                        className: 'dataEntry--duvets'
                    },
                    {
                        title: '26" x 26"',
                        rowSpan: '3',
                        className: 'dataEntry--duvets'
                    }
                ],
                [
                    'FULL/<br class="u-hidden--sm-up" />QUEEN',
                    '96" x 96"'
                ],
                [
                    'KING/<br class="u-hidden--sm-up" />CAL KING',
                    '106" x 96"',
                    {
                        title: `<span class="${styles['tableCell--leftBumper']}">King </br> 20" x 36"</span>`,
                        className: 'dataEntry--duvets'
                    }
                ]
            ]
        },
        footer: {
            listContent: [
                '<span class="t-bold">Quilt Only</span> does not include pillow shams',
                '<span class="t-bold">Twin and Twin XL</span> Quilt & Sham Sets include 1 pillow sham.',
                '<span class="t-bold">Full/Queen and King/Cal King</span> Quilt & Sham Sets include 2 shams.'
            ]
        }
    },
    [`${LINEN_SHEET_SET}`]: {
        head: {
            content: [
                '',
                {
                    title: 'Flat Sheet',
                    subtitle: 'W x L'
                },
                {
                    title: 'Fitted Sheet',
                    subtitle: 'W x L x D'
                },
                {
                    title: 'Pillowcase',
                    subtitle: 'W x L'
                }
            ]
        },
        body: {
            content: [
                [
                    'TWIN',
                    '72" x 110"',
                    '39" x 75" x 16"',
                    {
                        title: '<span>Standard/Queen </br> 32" x 21"</span>',
                        rowSpan: '4',
                        className: 'dataEntry--pillows'
                    }
                ],
                [
                    'TWIN XL',
                    '72" x 114"',
                    '39" x 80" x 16"'
                ],
                [
                    'FULL',
                    '92" x 110"',
                    '54" x 75" x 16"'
                ],
                [
                    'QUEEN',
                    '96" x 114"',
                    '60" x 80" x 16"'
                ],
                [
                    'KING',
                    '114" x 114"',
                    '76" x 80" x 16"',
                    {
                        title: '<span>King </br> 41" x 21"</span>',
                        rowSpan: '2',
                        classNameList: `${styles['dataEntry--pillows']} ${styles['dataEntry--borderBottom']}`
                    }
                ],
                [
                    'CAL KING',
                    '108" x 114"',
                    '72" x 84" x 16"'
                ]
            ]
        },
        footer: {
            listContent: [
                '<span class="t-bold">Fitted Sheet</span> fits mattresses 10-16 inches in height.',
                '<span class="t-bold">Twin and Twin XL</span> sets include 1 pillowcase, all other sizes include 2 pillowcases.'
            ]
        }
    },
    [`${ORGANIC_VELVET_QUILT}`]: {
        head: {
            content: [
                '',
                {
                    title: 'Quilts',
                    subtitle: 'W x L'
                },
                {
                    title: 'Pillow Shams',
                    subtitle: 'W x L',
                    titleClassName: 'tableCell--leftBumper'
                },
                {
                    title: 'Euro Shams',
                    subtitle: 'W x L'
                }
            ]
        },
        body: {
            content: [
                [
                    'FULL/<br class=\'u-hidden--sm-up\' />QUEEN',
                    '96" x 96"',
                    {
                        title: `<span class="${styles['tableCell--leftBumper']}">Standard </br> 20" x 26"</span>`,
                        className: 'dataEntry--duvets'
                    },
                    {
                        title: '26" x 26"',
                        rowSpan: '2',
                        className: 'dataEntry--duvets'
                    }
                ],
                [
                    'KING/<br class="u-hidden--sm-up" />CAL KING',
                    '112" x 96"',
                    {
                        title: `<span class="${styles['tableCell--leftBumper']}">King </br> 20" x 36"</span>`,
                        className: 'dataEntry--duvets'
                    }
                ]
            ]
        },
        footer: {
            listContent: [
                '<span class="t-bold">Quilt Only</span> does not include pillow shams.',
                '<span class="t-bold">Full/Queen and King/Cal King</span> Quilt & Sham Sets include 2 shams.'
            ]
        }
    },
    [`${WAFFLE_KNIT_BLANKET}`]: {
        head: {
            content: [ // Each object corresponds to a <th>
                '',
                {
                    subtitle: 'W x L'
                }
            ]

        },
        body: {
            content: [ // Each array correstpond to a <tr>
                [
                    'THROW',
                    '50" x 70"'
                ],
                [
                    'TWIN/TWIN XL',
                    '74" x 91"'
                ],
                [
                    'FULL/QUEEN',
                    '96" x 96"'
                ],
                [
                    'KING/CAL KING',
                    '112" x 96"'
                ]
            ]
        }
    },
    [`${SWEATER_KNIT_BLANKET}`]: {
        head: {
            content: [
                '',
                {
                    subtitle: 'W x L'
                }
            ]

        },
        body: {
            content: [
                [
                    'THROW',
                    '50" x 70"'
                ],
                [
                    'TWIN/TWIN XL',
                    '74" x 91"'
                ],
                [
                    'FULL/QUEEN',
                    '96" x 96"'
                ],
                [
                    'KING/CAL KING',
                    '112" x 96"'
                ]
            ]
        }
    },
    [`${ESSENTIAL_SHEET_SET}`]: {
        head: {
            className: '',
            content: [ // Each object corresponds to a <th>
                '',
                {
                    title: 'Flat Sheet',
                    subtitle: 'W x L'
                },
                {
                    title: 'Fitted Sheet',
                    subtitle: 'W x L x D'
                },
                {
                    title: 'Pillowcase',
                    subtitle: 'W x L'
                }
            ]
        },
        body: {
            content: [ // Each array correstpond to a <tr>
                [
                    'Twin',
                    '72" x 110"',
                    '39" x 75" x 16"',
                    {
                        title: 'Standard/Queen </br>32" x 21"',
                        rowSpan: '4',
                        className: 'dataEntry--pillows'
                    }
                ],
                [
                    'TWIN XL',
                    '72" x 114"',
                    '39" x 80" x 16"'
                ],
                [
                    'FULL',
                    '92" x 110"',
                    '54" x 75" x 16"'
                ],
                [
                    'QUEEN',
                    '96" x 114"',
                    '60" x 80" x 16"'
                ],
                [
                    'KING',
                    '114" x 114"',
                    '76" x 80" x 16"',
                    {
                        title: 'King </br>41" x 21"',
                        rowSpan: '3',
                        className: 'dataEntry--pillows'
                    }
                ],
                [
                    'CAL KING',
                    '108" x 114"',
                    '72" x 84" x 16"'
                ],
                [
                    'SPLIT KING',
                    '114" x 114"',
                    '39" x 80" x 16" (x2)'
                ]
            ]
        },
        footer: {
            listContent: [
                '<span class="t-bold">Fitted Sheet</span> fits mattresses 10-16 inches in height',
                '<span class="t-bold">Twin and Twin XL</span> sets include 1 pillowcase, all other sizes include 2 pillowcases.',
                '<span class="t-bold">Split King</span> set includes 2 fitted sheets.'
            ]
        }
    },
    [`${WEIGHTED_BLANKET}`]: {
        head: {
            content: [
                'Weighted Blankets',
            ]
        },
        body: {
            content: [
                [
                    'THROW (12 lbs)',
                    '48" x 74"'
                ],
                [
                    'QUEEN/KING (20 lbs)',
                    '86" x 92"'
                ]
            ]
        },
        footer: {
            listContent: [
                'Both blanket sizes offer the same weight per square foot and provide the same comforting benefits.',
                '<span class="t-bold">Single</span> size is perfect for solo sleepers or for use as a throw blanket.',
                '<span class="t-bold">Queen/King</span> size is meant for use on queen and king size beds.'
            ]
        }
    },
    [`${THE_SAATVA_PILLOW}`]: {
        head: {
            content: []
        },
        body: {
            content: [
                [
                    'Standard/Queen: 28” x 18”',
                ],
                [
                    'King: 34” x 18”',
                ]
            ]
        },
        footer: {
            listContent: [
                'Available in two different loft heights: Standard Loft (4-5”) and High Loft (6-7”)'
            ]
        }
    },
    [`${ORGANIC_QUILTED_PILLOW}`]: {
        head: {
            content: [ 
                'Sizes',
            ]
        },
        body: {
            content: [
                [
                    'Queen: 28" x 18"',
                ],
                [
                    'King: 34" x 18"',
                ]
            ]
        },
        footer: {
            listContent: [
                'Available in two different loft heights: Standard Loft (4-5”) and High Loft (6-7”)'
            ]
        }
    },
    [`${MEMORY_FOAM_PILLOW}`]: {
        head: {
            content: [ 
                'Sizes',
            ]
        },
        body: {
            content: [
                [
                    'Standard/Queen: 28" x 16"',
                ],
                [
                    'King: 34" x 16"',
                ]
            ]
        },
        footer: {
            listContent: [
                'Available in two different loft heights: Standard Loft (4-5”) and High Loft (6-7”)'
            ]
        }
    },
    [`${DOWN_ALTERNATIVE_PILLOW}`]: {
        head: {
            content: [ 
                'Sizes',
            ]
        },
        body: {
            content: [
                [
                    'Standard/Queen: 26” x 16”',
                ],
                [
                    'King: 34” x 16”',
                ]
            ]
        },
        footer: {
            listContent: [
                'Available in two different loft heights: Standard Loft (4-5”) and High Loft (6-7”)'
            ]
        }
    },
    [`${CLOUD_MEMORY_FOAM_PILLOW}`]: {
        head: {
            content: [ 
                'Sizes',
            ]
        },
        body: {
            content: [
                [
                    'Standard/Queen: 28” x 16”',
                ],
                [
                    'King: 34” x 16”',
                ]
            ]
        },
        footer: {
            listContent: [
                'Available in two different loft heights: Standard Loft (4-5”) and High Loft (6-7”)'
            ]
        }
    },
    [`${SILK_PILLOWCASE}`]: {
        head: {
            content: []
        },
        body: {
            content: [
                [
                    'Standard',
                    '32" x 21"'
                ],
                [
                    'King',
                    '41" x 21"'
                ]
            ]
        },
    },
    [`${ORGANIC_MATTRESS_PAD}`]: sharedSizes('MATTRESS PAD', true, true)[ORGANIC_MATTRESS_PAD],
    [`${SIGNATURE_MATTRESS_PAD}`]: sharedSizes('MATTRESS PAD', true, true)[ORGANIC_MATTRESS_PAD],
    [`${GRAPHITE_MEMORY_FOAM_MATTRESS_TOPPER}`]: sharedSizes('TOPPER', false)[ORGANIC_MATTRESS_PAD],
    [`${HIGH_DENSITY_FOAM_MATTRESS_TOPPER}`]: sharedSizes('TOPPER', false)[ORGANIC_MATTRESS_PAD],
    [`${MICROCOIL_MATTRESS_TOPPER}`]: sharedSizes('TOPPER', false)[ORGANIC_MATTRESS_PAD],
    [`${FEATHERBED_MATTRESS_TOPPER}`]: sharedSizes('TOPPER', false)[ORGANIC_MATTRESS_PAD],
    [`${LATEX_MATTRESS_TOPPER}`]: sharedSizes('TOPPER', false)[ORGANIC_MATTRESS_PAD],
    [`${ORGANIC_QUILTED_MATTRESS_TOPPER}`]: sharedSizes('TOPPER', false)[ORGANIC_MATTRESS_PAD],
    [`${DIAMOND_KNIT_BLANKET}`]: sharedSizes()[DIAMOND_KNIT_BLANKET],
    [`${HERRINGBONE_KNIT_BLANKET}`]: sharedSizes()[DIAMOND_KNIT_BLANKET],
    [`${ORGANIC_COTTON_SHEETS}`]: sharedSizes()[ORGANIC_COTTON_SHEETS],
    [`${WAFFLE_TOWELS}`]: sharedSizes()[WAFFLE_TOWELS],
    [`${PLUSH_TOWELS}`]: sharedSizes('Plush Towels')[WAFFLE_TOWELS],
    [`${PERCALE_DUVET_COVER_SET}`]: sharedSizes()[PERCALE_DUVET_COVER_SET],
    [`${ORGANIC_SATEEN_DUVET_COVER_SET}`]: sharedSizes()[PERCALE_DUVET_COVER_SET],
    [`${BANDED_PERCALE_DUVET_SET}`]: sharedSizes()[PERCALE_DUVET_COVER_SET],
    [`${WAFFLE_KNIT_DUVET_COVER_SET}`]: sharedSizes()[PERCALE_DUVET_COVER_SET],
    [`${EMBROIDERED_SATEEN_DUVET_SET}`]: sharedSizes()[PERCALE_DUVET_COVER_SET],
    [`${LINEN_DUVET_COVER_SET}`]: sharedSizes()[PERCALE_DUVET_COVER_SET],
    [`${PERCALE_SHEET_SET}`]: sharedSizes()[PERCALE_SHEET_SET],
    [`${EMBROIDERED_HOTEL_STYLE_SHEETS}`]: sharedSizes()[PERCALE_SHEET_SET],
    [`${BANDED_PERCALE_SHEET_SET}`]: sharedSizes()[PERCALE_SHEET_SET],
    [`${FLANNEL_SHEET_SET}`]: sharedSizes()[PERCALE_SHEET_SET],
    [`${SATEEN_COTTON_SHEET_SET}`]: sharedSizes()[ORGANIC_COTTON_SHEETS],
    [`${WATERPROOF_MATTRESS_PROTECTOR}`]: sharedSizes('MATTRESS PROTECTOR', true)[ORGANIC_MATTRESS_PAD],
    [`${DOWN_ALTERNATIVE_COMFORTER}`]: sharedSizes()[DOWN_ALTERNATIVE_COMFORTER],
    [`${LIGHTWEIGHT_DOWN_ALTERNATIVE_COMFORTER}`]: sharedSizes()[DOWN_ALTERNATIVE_COMFORTER],
    [`${HEAVYWEIGHT_COMFORTER}`]: sharedSizes()[DOWN_ALTERNATIVE_COMFORTER],
    [`${ESSENTIAL_DUVET_COVER_SET}`]: sharedSizes('', false, false, 2)[PERCALE_DUVET_COVER_SET],
    [`${SIGNATURE_DUVET_COVER_SET}`]: sharedSizes('', false, false, 2)[PERCALE_DUVET_COVER_SET],
    [ORGANIC_COTTON_PILLOWCASES]: sharedSizes()['pillowcases'],
    [PERCALE_PILLOWCASES]: sharedSizes()['pillowcases'],
    [SATEEN_COTTON_PILLOWCASES]: sharedSizes()['pillowcases'],
    [BANDED_PERCALE_PILLOWCASES]: sharedSizes()['pillowcases'],
    [LINEN_PILLOWCASES]: sharedSizes()['pillowcases'],
    [ESSENTIAL_PILLOWCASES]: sharedSizes()['pillowcases'],
    [FLANNEL_PILLOWCASES]: sharedSizes()['pillowcases'],
    [EMBROIDERED_PILLOWCASES]: sharedSizes()['pillowcases'],
}

export default sizeGuide
